import $ from 'jquery';

$(document).ready(function () {

    $(document).on("keydown", 'form.checkout', function(e) {

        if(e.keyCode == 13) {

            e.preventDefault();

            if($(e.target).hasClass('qty')) {
                inputUpdate($(e.target).val(), $(e.target))
            }

            return false;
        }
    });

    $("form.checkout").on("click", "button.amount-trigger", function(e) {

        e.preventDefault();

        let inputField = $(this).parent().parent().find('input');
        let inputValue = parseInt(inputField.val());

        if($(this).hasClass('plus-amount')) {
            inputValue = inputValue + 1;
        }

        if($(this).hasClass('minus-amount')) {
            if(inputValue === 0) return
            inputValue = inputValue - 1;
        }

        inputUpdate(inputValue, inputField)

    });

    function inputUpdate(newValue, input) {

        var inputValue = newValue;
        var max = input.attr('max');
        
        if(max !== undefined) {

            max = parseInt(max);
         
            if(inputValue > max) {
                inputValue =  max
            }

        }

        input.val(inputValue);
        triggerCartUpdate();
    }

    const triggerCartUpdate = debounce( () => {

        var data = {
            action: 'tigger_cart_update',
            post_data: $( 'form.checkout' ).serialize()
        };

		$.ajax({
			url: ajaxurl,
			type: 'post',
			data: data,
			error: function (response) {
				console.log(response)
			},
			success: function (response) {

                if(response) {

					if(response.fragments && response.fragments['#checkout-mobile']) {
						$('#checkout-mobile').replaceWith(response.fragments['#checkout-mobile'])
					}

					if(response.fragments && response.fragments['#checkout']) {						
						$('#checkout').replaceWith(response.fragments['#checkout'])
					}

                    if(response.fragments && response.fragments) {
                        jQuery( 'body' ).trigger( 'update_checkout' );
                    }

                    if(response.redirect) {
                        window.location.href = response.redirect;
                    }

                }

			},
		});

    }, 300)


    // #cart-upgrade

    jQuery( 'body' ).on( 'updated_checkout', function() {
        
        if( jQuery(document).find('#cart-upgrade-wrapper').length ) {
            cart_upgrade()
        }

    } );

    // #cart-upgrade
    jQuery( 'body' ).on('update_checkout', function() {

        if( jQuery(document).find('#cart-upgrade-wrapper').length ) {
            jQuery(document).find('.cart-upgrade').addClass('loading')
        }

    });

    function cart_upgrade() {

        var data = {
            action: 'get_cart_upgrade'
        };

		$.ajax({
			url: ajaxurl,
			type: 'get',
			data: data,
			error: function (response) {
				console.log(response)
			},
			success: function (response) {
                console.log('test')

                if( response && response.hide ) {
                    $('#cart-upgrade-wrapper').empty()
                    return
                }

                if($('#cart-upgrade').length) {
                    $('#cart-upgrade').replaceWith( response.cart_upgrade )
                } else {
                    $('#cart-upgrade-wrapper').append(response.cart_upgrade)
                }

                if(!$('#progress-cart-upgrade').length) {
                    $('#cart-upgrade-wrapper').append(response.cart_upgrade_progress)
                }

                const progressbar = $('#progress-cart-upgrade')

                const val = response.value

                const max = response.max

                progressbar.attr('max', max)

                progressbar.val(val)

                progressbar.parent().find('span').text(response.progress)

                jQuery(document).find('.cart-upgrade').removeClass('loading')

			},
		});

    }

    function debounce(callback, delay = 1000) {

        let timeout;
    
        return (...args) => {
            clearTimeout(timeout)
    
            timeout = setTimeout(() => {
                callback(...args)
            }, delay)
        }
    }

});